import React from "react";
import EditButton from "./EditButton";
import DeleteButton from "./DeleteButton";
import RouteService from "../../../../services/routes/RouteService";
import {AOperation} from "../../../../models/operations/AOperation";
import OperationLocalService from "../../../../services/storage/localStorage/OperationLocalService";
import {autoFormatDate, DATE_FORMAT_WITH_TIME} from "../../../../services/UtilsService";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    operation: AOperation
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 31/05/2022
 * @last_update 31/05/2022
 **/
class ActionButtons extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        const onDeleteClick = () => {
            if(!this.props.operation.isSynchro) {
                OperationLocalService.deleteOperation(this.props.operation);
            }
        }

        const deleteConfirmationContent = getTranslation(
            "pages.map.marker.modal.action-buttons.delete.alert.content",
            {date: autoFormatDate(this.props.operation.date, DATE_FORMAT_WITH_TIME)}
        );

        const routerLink = RouteService.getEditOperationWithoutParam() + this.props.operation.id;

        return (

            <div>
                <EditButton routerLink={routerLink}/>
                <DeleteButton onClick={onDeleteClick} confirmationContent={deleteConfirmationContent}/>
            </div>

        );

    };

}

export default withTranslation()(ActionButtons);
